<nb-alert status="danger">
    {{error}}
</nb-alert>
<a [routerLink]="['/auth/login']" fullWidth nbButton status="danger">
    Cliquez ici pour revenir à la page de connexion
</a>
